import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import mg1 from "../assets/1736617763762__1_-removebg-preview.png"

const Navbar = ({ toggleDarkMode }) => {
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <>
            <nav className="fixed top-0 w-full z-50 backdrop-blur-md bg-background-light/80 dark:bg-background-dark/80">
                <div className="container max-w-6xl mx-auto border mt-4 rounded-full border-border-light dark:border-border-dark px-4 sm:px-6 py-2 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-gradient-to-br from-purple-500 to-primary flex items-center justify-center text-white font-bold text-sm">
                            <img className='w-full h-full rounded-full' src={mg1} alt="Md.Azaharul Profile" />
                        </div>
                    </div>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex items-center gap-8 text-sm font-medium">
                        <Link
                            className={`transition-colors ${location.pathname === '/' ? 'text-primary' : 'hover:text-primary'}`}
                            to="/"
                        >
                            Home
                        </Link>
                        <Link
                            className={`transition-colors ${location.pathname === '/about' ? 'text-primary' : 'hover:text-primary'}`}
                            to="/about"
                        >
                            About
                        </Link>
                        <Link
                            className={`transition-colors ${location.pathname === '/portfolio' ? 'text-primary' : 'hover:text-primary'}`}
                            to="/portfolio"
                        >
                            Portfolio
                        </Link>
                        <a className="hover:text-primary transition-colors" href="#certificates">Certificates</a>
                    </div>

                    <div className="hidden md:flex items-center gap-4">
                        <Link
                            className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors ${location.pathname === '/contact'
                                ? 'bg-primary text-white'
                                : 'bg-white dark:bg-white text-black hover:bg-gray-200'
                                }`}
                            to="/contact"
                        >
                            Contact Me
                        </Link>
                        <button
                            className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-800 transition-colors"
                            onClick={toggleDarkMode}
                        >
                            <span className="material-icons-round text-base">brightness_4</span>
                        </button>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden flex items-center gap-2">
                        <button
                            className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-800 transition-colors"
                            onClick={toggleDarkMode}
                        >
                            <span className="material-icons-round text-base">brightness_4</span>
                        </button>
                        <button
                            className="text-gray-800 dark:text-white p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-800 transition-colors"
                            onClick={toggleMobileMenu}
                            aria-label="Toggle mobile menu"
                        >
                            <span className="material-icons-round">
                                {isMobileMenuOpen ? 'close' : 'menu'}
                            </span>
                        </button>
                    </div>
                </div>
            </nav>

            {/* Mobile Menu Overlay */}
            {isMobileMenuOpen && (
                <div
                    className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm md:hidden"
                    onClick={closeMobileMenu}
                />
            )}

            {/* Mobile Menu */}
            <div className={`fixed top-0 right-0 h-full w-full z-50 bg-background-light dark:bg-background-dark border-l border-border-light dark:border-border-dark transform transition-transform duration-300 ease-in-out md:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
                }`}>
                <div className="flex flex-col h-full">
                    {/* Mobile Menu Header */}
                    <div className="flex items-center justify-between p-6 border-b border-border-light dark:border-border-dark">
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-primary flex items-center justify-center">
                                <img className='w-full h-full rounded-full' src={mg1} alt="Md.Azaharul Profile" />
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-900 dark:text-white">Md.Azaharul</h3>
                                <p className="text-xs text-gray-600 dark:text-gray-400">MERN Stack Developer</p>
                            </div>
                        </div>
                        <button
                            onClick={closeMobileMenu}
                            className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-800 transition-colors"
                            aria-label="Close mobile menu"
                        >
                            <span className="material-icons-round text-gray-600 dark:text-gray-400">close</span>
                        </button>
                    </div>

                    {/* Mobile Menu Navigation */}
                    <div className="flex-1 py-6">
                        <nav className="space-y-2 px-6">
                            <Link
                                to="/"
                                onClick={closeMobileMenu}
                                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${location.pathname === '/'
                                    ? 'bg-primary/10 text-primary border border-primary/20'
                                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                                    }`}
                            >
                                <span className="material-icons-round text-xl">home</span>
                                <span className="font-medium">Home</span>
                                {location.pathname === '/' && (
                                    <span className="ml-auto w-2 h-2 bg-primary rounded-full"></span>
                                )}
                            </Link>

                            <Link
                                to="/about"
                                onClick={closeMobileMenu}
                                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${location.pathname === '/about'
                                    ? 'bg-primary/10 text-primary border border-primary/20'
                                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                                    }`}
                            >
                                <span className="material-icons-round text-xl">person</span>
                                <span className="font-medium">About</span>
                                {location.pathname === '/about' && (
                                    <span className="ml-auto w-2 h-2 bg-primary rounded-full"></span>
                                )}
                            </Link>

                            <Link
                                to="/portfolio"
                                onClick={closeMobileMenu}
                                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${location.pathname === '/portfolio' || location.pathname.startsWith('/portfolio/')
                                    ? 'bg-primary/10 text-primary border border-primary/20'
                                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                                    }`}
                            >
                                <span className="material-icons-round text-xl">work</span>
                                <span className="font-medium">Portfolio</span>
                                {(location.pathname === '/portfolio' || location.pathname.startsWith('/portfolio/')) && (
                                    <span className="ml-auto w-2 h-2 bg-primary rounded-full"></span>
                                )}
                            </Link>

                            <a
                                href="#certificates"
                                onClick={closeMobileMenu}
                                className="flex items-center gap-3 px-4 py-3 rounded-lg transition-colors text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
                            >
                                <span className="material-icons-round text-xl">school</span>
                                <span className="font-medium">Certificates</span>
                            </a>

                            <Link
                                to="/contact"
                                onClick={closeMobileMenu}
                                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${location.pathname === '/contact'
                                    ? 'bg-primary/10 text-primary border border-primary/20'
                                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                                    }`}
                            >
                                <span className="material-icons-round text-xl">mail</span>
                                <span className="font-medium">Contact</span>
                                {location.pathname === '/contact' && (
                                    <span className="ml-auto w-2 h-2 bg-primary rounded-full"></span>
                                )}
                            </Link>
                        </nav>
                    </div>

                    {/* Mobile Menu Footer */}
                    <div className="p-6 border-t border-border-light dark:border-border-dark">
                        <Link
                            to="/contact"
                            onClick={closeMobileMenu}
                            className="w-full bg-primary text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary/90 transition-colors flex items-center justify-center gap-2"
                        >
                            <span className="material-icons-round text-sm">send</span>
                            Get In Touch
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Navbar;